module.exports = __webpack_public_path__ + "assets/images/device_android_mobile_rivers.svg";